import React, { useCallback, useEffect, useState } from "react";

import { getAllInvekos } from "services";

import { goTo, useCancelAsyncOnUnmount } from "utils";

import { AdminHead, AdminTable, Button, Col, MainPage, Row } from "components";

export const ShapefileList = () => {
  const [loading, setLoading] = useState(true);
  const [invekos, setInvekos] = useState([]);
  const signal = useCancelAsyncOnUnmount()();

  const download = (file) => {
    goTo(null, null, file, true);
  };

  const loadAllInvekos = useCallback(() => {
    getAllInvekos({
      signal,
    })
      .then((res) => {
        setInvekos(res.length > 0 ? res : []);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  useEffect(() => {
    loadAllInvekos();
  }, [loadAllInvekos]);

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline={`${invekos.length} shapefiles`}
        description={
          <>
            All the shapefiles uploaded are available here. If you upload a file, it will be processed and the farm's fields will be updated.{" "}
            <b>Only admin users can access the files.</b>
          </>
        }
        extra={
          <Button size="small" type="secondary" href="/shapefile/updates">
            Settings
          </Button>
        }
      />
      <Row>
        <Col>
          {!loading && (
            <AdminTable
              dataSource={invekos}
              config={{
                actions: [
                  {
                    icon: "klim/farm",
                    route: "/farm/",
                    record: "farmId",
                    tooltip: "View this farm",
                  },
                  {
                    icon: "tabler/download",
                    func: download,
                    arguments: ["file"],
                    tooltip: "Download this file",
                  },
                ],
                exclude: ["farmId", "file", "id", "updated", "utc"],
              }}
            />
          )}
        </Col>
      </Row>
    </MainPage>
  );
};
